module.exports = __webpack_public_path__ + "img/full6-min.a258b978.png";